import React, { useState } from 'react';
import { Modal, Checkbox, Row, Col } from 'antd'

interface HeaderOption {
    label: string;
    value: string;
}
const headersOptions: HeaderOption[] = [
    { label: "Request ID", value: "Request ID" },
    { label: "Nhà mạng", value: "Nhà mạng" },
    { label: "SĐT nhận", value: "SĐT nhận" },
    { label: "Nhà CC", value: "Nhà CC" },
    { label: "Giá nhà CC", value: "Giá nhà CC" },
    { label: "Đối tác", value: "Đối tác" },
    { label: "Đối tác thanh toán", value: "Đối tác thanh toán" },
    { label: "Lợi nhuận", value: "Lợi nhuận" },
    { label: "Message NCC", value: "Message NCC" },
    { label: "Trạng thái", value: "Trạng thái" },
    { label: "Thời gian", value: "Thời gian" }
];

const ExportExcelSmsHeaderModal: React.FC<{ visible: boolean, onOk: (selectedHeaders: string[]) => void, onCancel: () => void }> = ({ visible, onOk, onCancel }) => {
    const [selectedHeaders, setSelectedHeaders] = useState<string[]>(headersOptions.map(option => option.value));

    const handleOk = () => {
        onOk(selectedHeaders);
    };

    const handleCheckboxChange = (checkedValues: any) => {
        setSelectedHeaders(checkedValues);
    };

    return (<Modal title="Chọn Header" open={visible} onOk={handleOk} onCancel={onCancel} width={800}> <Checkbox.Group style={{ width: '100%' }} defaultValue={selectedHeaders} onChange={handleCheckboxChange}> <Row> {headersOptions.map(option => (<Col span={8} key={option.value} style={{ marginBottom: '10px' }}> <Checkbox value={option.value}>{option.label}</Checkbox> </Col>))} </Row> </Checkbox.Group> </Modal>);
};

export default ExportExcelSmsHeaderModal;